import {Stack} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {NavItem} from "../../components/NavItem";
import IconChevronRight from "../../assets/chevron-right.svg?react";
import {useNewsGroupings} from "./useNewsGroupings";
import layoutClasses from "./DashboardView.module.css";
import classes from "./NewsFilterSidebar.module.css";

/**
 * Desktop-only sidebar for the News tab: single-select portal-grouping (area)
 * filter, occupying the same layout slot as the portals groupings sidebar.
 * Areas with no news from the selected source are shown disabled rather than
 * removed, so the list doesn't reshuffle as sources change.
 * Sources are not listed here — they are filtered by clicking an article's
 * source pill. Filter state lives in URL search params (see useNewsFilters).
 */
export function NewsFilterSidebar() {
    const {t} = useTranslation();
    const groupings = useNewsGroupings();

    return (
        <Stack
            miw={200}
            maw={250}
            gap={0}
            w="100%"
            className={layoutClasses.sidebar}
        >
            <div className={classes.group}>
                <NavItem
                    onClick={groupings.clear}
                    active={!groupings.selectedSlug}
                    rightSection={
                        !groupings.selectedSlug && <IconChevronRight />
                    }
                >
                    {t("News.allAreas", {defaultValue: "All areas"})}
                </NavItem>
                {groupings.options.map((option) => (
                    <NavItem
                        key={option.slug}
                        onClick={() => groupings.toggle(option.slug)}
                        active={groupings.selectedSlug === option.slug}
                        disabled={option.disabled}
                        rightSection={
                            groupings.selectedSlug === option.slug && (
                                <IconChevronRight />
                            )
                        }
                    >
                        {option.name}
                    </NavItem>
                ))}
            </div>
        </Stack>
    );
}
